import { Image, SimpleGrid } from '@chakra-ui/react';

const SameTraits: React.FC = () => {
  const tempArr = new Array(13).fill(0);

  return (
    <SimpleGrid minChildWidth="250px" spacing="16px">
      {tempArr.map((val, index) => (
        <Image
          key={index++}
          src={`/assets/mint/same-traits/year_${index + 1}_same_traits.jpg`}
          shadow="md"
          rounded="sm"
        />
      ))}
    </SimpleGrid>
  );
};

export default SameTraits;
